import { Button, Popover, Icon } from 'antd';
import AfspLoginModal from './AfspLoginModal';
import AfspRegistrationOptions from './AfspRegistrationOptions';
import { ssFormUtils, ssCommonUtils, ssSessionUtils } from '@bit/ui-common.ui-components/ss-utils';
import * as config from './forms/formConfig';
import AfspAcknowledgment from '@bit/ui-common.ui-components/afsp/react/components/AfspAcknowledgement';

const 

{ htmlStorage, logout } = ssSessionUtils,
{ setEnvPrefix, getDataType } = ssCommonUtils,
{ generateInitState, formRedirect } = ssFormUtils;
let sessionSuccess;

export default class extends React.Component {

    state = {
		
        showAcknowledgement: false,
        userRole: "c",
        description: "Candidate login acknowledgement statement", 

    };

    constructor(props) { 
        super(props); 
        this.initFormState();
    }

    initFormState() {
        let formConfig = {...config};
        const { services, state: { registrationForm }} = this.props;
        delete formConfig.linkedFormFields;
        for(let f in formConfig) {
            let config = formConfig[f];
            if(!registrationForm[config.key]) 
                services.storeForm(config.key, generateInitState(config));
        }
    }

    getButtonProps(btnIcon='', btnSize='small') {
        const 
        { size } = this.props,
        props = { 
            style: { borderRadius: '4px', width: '130px' },
            type: 'primary'
        };

        switch(size) {
            case 'xs': return {...props, icon: btnIcon, size: btnSize, style: {...props.style, width: '130px' }};
            case 'sm': return {...props, icon: btnIcon, size: btnSize, style: {...props.style, width: '135px' }};
            case 'md': return {...props, icon: btnIcon, size: btnSize, style: {...props.style, width: '140px' }};
            case 'lg': return {...props, icon: btnIcon, size: btnSize, style: {...props.style, width: '170px' }};
            default: return {...props};
        }
    }

    componentDidUpdate(prev) {
        const
        cLoginStatus = this.props.state.login.loginRequest.status,
        pLoginStatus = prev.state.login.loginRequest.status,
        session = htmlStorage().get('ssSession');

        if (pLoginStatus !== 'success' && cLoginStatus === 'success' && session != null){

            if ((htmlStorage().get('ssSession')).jwtSession.ROLES[0] === "CANDIDATE"){

                this.setState({ userRole : "c"});
                this.setState({description: "Candidate login acknowledgement statement"}); 
                this.setState({ showAcknowledgement : true});
                sessionSuccess = htmlStorage().get('ssSession');
                htmlStorage().set({ssSession:null});


            }else if ((htmlStorage().get('ssSession')).jwtSession.ROLES[0].includes("PROVIDER")){

                this.setState({ userRole : "p"});
                this.setState({description: "Provider login acknowledgement statement"}); 
                this.setState({ showAcknowledgement : true});
               sessionSuccess = htmlStorage().get('ssSession');
                htmlStorage().set({ssSession:null});
             
                
            }
            else {
                
                formRedirect(setEnvPrefix('/session/redirect'), { token: (htmlStorage().get('ssSession')).token });

            }


        }
    }



    render() {
        let http = new XMLHttpRequest();
        let path = '/home';


        const { services, size, registrationPath } = this.props;
        return (
            <div>
               <AfspAcknowledgment 
                        showAcknowledgement = {this.state.showAcknowledgement} 
                        role = {this.state.userRole}
                        description = {this.state.description}
                        onAccept= {() =>{
                            htmlStorage().set({ssSession: sessionSuccess});
                            formRedirect(setEnvPrefix('/session/redirect'), { token: htmlStorage().get('ssSession').token });
                             }} 
                        onDeny= {() =>{

                            window.location.reload(); 

                            }}  
                        denyButton={true}/>
 
              
                        
                <AfspLoginModal {...this.props} />
                <div className={size !== 'xs' ? null : 'afsp-login-xs-container'}>
                    <div className={`afsp-login-${size != null ? size : 'md'}-login`}>
                        <Button 
                            {...this.getButtonProps('login', size !== 'lg' ? 'small' : '')}
                            onClick={() => services.toggleAfspLoginModal()}
                         
                            aTag = "common login button"
                            id = "common login button"
                        >
                            {'Log In'}
                        </Button>
                    </div>
                    <div className={`afsp-login-${size != null ? size : 'md'}-register`}>
                        {getDataType(registrationPath) === 'String' ? (
                            <Button 
                                {...this.getButtonProps('user-add', size !== 'lg' ? 'small' : '')}
                                onClick={() => {
                                    if (registrationPath != null && registrationPath.length > 0) 
                                        window.location.href = setEnvPrefix(registrationPath);
                                    else window.location.href = window.location.pathname;
                                }}
                            >
                                {'Register'}
                            </Button>
                        ) : getDataType(registrationPath) === 'Array' ? (
                            <Popover 
                                style={{ backgroundColor: 'red' }}
                                trigger='click'
                                content={<AfspRegistrationOptions {...this.props} />}
                                title={
                                    <div className='afsp-login-popover-title'>
                                        <Icon type='user-add' style={{ marginRight: '4px' }} />
                                        <span>
                                            {'Registration Portals'}
                                        </span>
                                    </div>
                                }
                            >
                                <Button {...this.getButtonProps('bars', size !== 'lg' ? 'small' : '')}
                                    aTag = "common register button"
                                    id = "common register button"
                                >
                                    {'Register Options'}
                                </Button>
                            </Popover>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}
